import { render, staticRenderFns } from "./Brake.vue?vue&type=template&id=177c1ce7&scoped=true"
import script from "./Brake.vue?vue&type=script&lang=js"
export * from "./Brake.vue?vue&type=script&lang=js"
import style0 from "./Brake.vue?vue&type=style&index=0&id=177c1ce7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c1ce7",
  null
  
)

export default component.exports